import React from "react";

export const SelectAllDays = ({isChecked, onChange}) => {

  return (
    <div className="select-all-container">
      <input 
        type="checkbox" 
        id="allDays" 
        checked={isChecked} 
        onChange={onChange}
      />
      <label for="allDays">Every Day</label>
    </div>
  )
}

export const DayCheckBox = ({data, checkBoxHandler}) => {
  
  return (
    <ul className="days-section">
      {
        data.map((value) => 
          <li key={value.day}>
            <input 
              className="day-checkbox" 
              type="checkbox" 
              id={value.id} 
              checked={value.isChecked} 
              value={value.day} 
              onChange={(e)=>checkBoxHandler(e) }
            />
            <label for={value.id}>{ value.day[0]}</label>
          </li>
        )
      }
    </ul>
  )
}

